import { all } from 'redux-saga/effects';
import getPostsWatcher from './watchers/getPosts';
import deletePostWatcher from './watchers/deletePost';

function* answerTypesSaga() {
  yield all([getPostsWatcher(), deletePostWatcher()]);
}

export default answerTypesSaga;
